import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';
import { AspectRatioWrapper } from '../../../../components';

import css from './SectionCreateTutorProfile.module.css';
import img from './images/tutor.png';

const SectionCreateTutorProfile = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
    intl,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const aspectWidth = 1;
  const aspectHeight = 1;
  return (
    <SectionContainer
      id={sectionId}
      className={classNames(className)}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.container}>
        <div className={css.left}>
          {hasHeaderFields ? (
            <header className={classNames(css.header, defaultClasses.sectionDetails)}>
              <Field data={title} className={defaultClasses.title} options={fieldOptions} />
              <Field
                data={description}
                className={defaultClasses.description}
                options={fieldOptions}
              />
            </header>
          ) : null}

          <div className={css.blocksWrapper}>
            <div className={css.block}>
              <div className={css.blockNumber}>{'01'}</div>
              <div>
                <div className={css.blockTitle}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionCreateTutorProfile.howItWorks.signup',
                  })}
                </div>
                <div className={css.blockDetail}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionCreateTutorProfile.howItWorks.signupDetails',
                  })}
                </div>
              </div>
            </div>
            <div className={css.block}>
              <div className={css.blockNumber}>{'02'}</div>
              <div>
                <div className={css.blockTitle}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionCreateTutorProfile.howItWorks.intakeWithTeam',
                  })}
                </div>
                <div className={css.blockDetail}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionCreateTutorProfile.howItWorks.intakeWithTeamDetails',
                  })}
                </div>
              </div>
            </div>
            <div className={css.block}>
              <div className={css.blockNumber}>{'03'}</div>
              <div>
                <div className={css.blockTitle}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionCreateTutorProfile.howItWorks.startTutoring',
                  })}
                </div>
                <div className={css.blockDetail}>
                  {intl.formatMessage({
                    id: 'LandingPage.SectionCreateTutorProfile.howItWorks.startTutoringDetails',
                  })}
                </div>
              </div>
            </div>
          </div>
          <Field
            data={callToAction}
            className={classNames(css.cta, defaultClasses.ctaButton)}
            options={fieldOptions}
          />
        </div>
        <div className={css.right}>
          <AspectRatioWrapper
            className={css.aspectRatioWrapper}
            width={aspectWidth}
            height={aspectHeight}
          >
            <img className={css.rootForImage} alt={'tutor'} src={img} />
          </AspectRatioWrapper>
        </div>
      </div>
    </SectionContainer>
  );
};

SectionCreateTutorProfile.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionCreateTutorProfile.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
};

export default SectionCreateTutorProfile;
